<div class="controls">
  <fb-date-picker-display [text]="date()" label="Date" [muted]="muted()" [showPlaceholder]="!isPrinting()" />
  <fb-select-display
    [text]="procedureType()"
    placeholder="Select"
    label="Procedure Type"
    [muted]="muted()"
    [showPlaceholder]="!isPrinting()"
    [markerTarget]="markerTarget()"
    markerFieldKey="procedureType"
    [rowIndex]="rowIndex()"
  />
  <fb-select-display
    [text]="equipment()"
    placeholder="Select"
    label="Equipment"
    [muted]="muted()"
    [showPlaceholder]="!isPrinting()"
    [markerTarget]="markerTarget()"
    markerFieldKey="equipment"
    [rowIndex]="rowIndex()"
  />
  <fb-text-field-display
    [text]="serviceTime()"
    label="Service Time"
    [muted]="muted()"
    [showPlaceholder]="!isPrinting()"
    [markerTarget]="markerTarget()"
    markerFieldKey="serviceTime"
    [rowIndex]="rowIndex()"
  />
  <fb-text-field-display
    [text]="smartCool()"
    [label]="smartCoolLabel()"
    [muted]="muted()"
    [showPlaceholder]="!isPrinting()"
    [markerTarget]="markerTarget()"
    markerFieldKey="smartCool"
    [rowIndex]="rowIndex()"
  />
  <fb-text-field-display
    [text]="joules()"
    [label]="joulesLabel()"
    [muted]="muted()"
    [showPlaceholder]="!isPrinting()"
    [markerTarget]="markerTarget()"
    markerFieldKey="joules"
    [rowIndex]="rowIndex()"
  />
  <fb-text-field-display
    [text]="pulse()"
    [label]="pulseLabel()"
    [muted]="muted()"
    [showPlaceholder]="!isPrinting()"
    [markerTarget]="markerTarget()"
    markerFieldKey="pulse"
    [rowIndex]="rowIndex()"
  />
  <fb-text-field-display
    [text]="repetitionRate()"
    [label]="repetitionRateLabel()"
    [muted]="muted()"
    [showPlaceholder]="!isPrinting()"
    [markerTarget]="markerTarget()"
    markerFieldKey="repetitionRate"
    [rowIndex]="rowIndex()"
  />
  <fb-select-display
    [text]="firstLaserOption()"
    [label]="firstLaserOptionLabel()"
    [muted]="muted()"
    [showPlaceholder]="!isPrinting()"
    [markerTarget]="markerTarget()"
    markerFieldKey="firstLaserOption"
    [rowIndex]="rowIndex()"
  />
  <fb-select-display
    [text]="secondLaserOption()"
    [label]="secondLaserOptionLabel()"
    [muted]="muted()"
    [showPlaceholder]="!isPrinting()"
    [markerTarget]="markerTarget()"
    markerFieldKey="secondLaserOption"
    [rowIndex]="rowIndex()"
  />
  <div class="notes">
    <span class="notes-label">
      <span class="notes-label__content">
        <span>Notes</span>
        <fb-scribe-suggestion-indicator [target]="markerTarget()" fieldKey="note"></fb-scribe-suggestion-indicator>
        <fb-amendment-field-indicator [rowIndex]="rowIndex()" fieldKey="note" />
      </span>
    </span>
    <textarea
      appTextareaAutosize
      [appTextareaAutosizeUnlimited]="isPrinting()"
      class="notes-textarea"
      [placeholder]="isPrinting() ? '' : 'Notes'"
      readonly
      [value]="note()"
      [class.muted]="muted()"
    ></textarea>
  </div>
</div>
